import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { HttpEventType, HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Role } from '../models/role';
import { Timezone, State, Country, EmrVendor, Offering, CaptureApplicationMessage } from '../models/general';
import { MessageType, NotificationType } from '../index';

@Injectable()
export class GeneralService {

    constructor(private http: Http, private httpClient: HttpClient, private config: AppConfig) { }

    getTimezones(): Observable<Timezone[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/Timezones', { headers })
            .pipe(map((response: Response) => {
                // console.log(response);
                return <Timezone[]>response.json();
            }), catchError(this.handleError));
    }

    getStates(): Observable<State[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/states', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <State[]>response.json();
            }), catchError(this.handleError));
    }


    getCountries(): Observable<Country[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/countries', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <Country[]>response.json();
            }), catchError(this.handleError));
    }

    getEmrVendors(): Observable<EmrVendor[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/emrvendors', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <EmrVendor[]>response.json();
            }), catchError(this.handleError));
    }

    getOfferings(): Observable<Offering[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/offerings', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <Offering[]>response.json();
            }), catchError(this.handleError));
    }


    getMeasurementTypes(): Observable<any> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/measurementTypes', { headers })
            .pipe(map((response: Response) => {
                // console.log(response);
                return <any>response.json();
            }), catchError(this.handleError));
    }

    getMessageTypes(): Observable<MessageType[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/messageTypes', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <MessageType[]>response.json();
            }), catchError(this.handleError));
    }

    getNotificationTypes(): Observable<NotificationType[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/notificationTypes', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <NotificationType[]>response.json();
            }), catchError(this.handleError));
    }

    getTotalPccCalls(): Observable<any> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/totalpcccalls', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return response.json();
            }), catchError(this.handleError));
    }

    getCaptureApplicationMessage(): Observable<CaptureApplicationMessage> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/general/captureapplicationmessage', { headers })
            .pipe(map((response: Response) => {
                console.log(response);
                if (response.status == 204)
                    return new CaptureApplicationMessage();
                else
                    return response.json();
            }), catchError(this.handleError));
    }

    saveCaptureApplicationMessage(message): Observable<CaptureApplicationMessage> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/general/updatecaptureapplicationmessage', message, { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return response.json();
            }), catchError(this.handleError));
    }

    postFile(formData: FormData): Observable<any> {
        
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new HttpHeaders();
        //headers.append('Content-Type', 'multipart/form-data');
        //headers.append('Authorization', 'Bearer ' + authToken);
        return this.httpClient.post(this.config.apiUrl + '/api/general/uploadfile', formData,
            { reportProgress: true, observe: 'events', headers: new HttpHeaders({ 'Authorization': 'Bearer ' + authToken }) });
    }



    // private helper methods
    private handleError(error: Response) {
        return Observable.throw(error.statusText);
    }

    private jwt() {
        // create authorization header with jwt token
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
            return new RequestOptions({ headers: headers });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/general.service.ts